const ROUTES = {
  notfound: '*',
  login: '/login',
  home: '/',
  about: '/about',
  posts: '/posts',
  messages: '/messages',
  community: 'community',
  shops: '/shops',
  postDetail: '/posts/:postId',
  createStickers: '/create-stickers',
  listMarketStickers: '/list-market-sticker',
  listOwnerStickers: '/list-owner-sticker',
  chatThread: ':cid',
  preRegistration: '/pre-registration',
  main: '/home',
  error: '/error',
  available: '/pc-available',
  maintenance: '/maintenance',
  wallet: '/wallet',
  linkTelegram: '/link-telegram',
  discordConnect: '/discord-connect',
  notification: 'notification',
  user: 'user',
  nftSale: '/nft-sale',
};

export default ROUTES;
